import { useSuspenseQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { i18nService } from '@avanta/shared/services/i18n';
import { UsersService } from '@avanta/shared/services/users';
import { type User } from '@avanta/shared/types/users';

export interface UseSuspenseFetchUserOptions {
  setUser: (user: User) => void;
}

export const useSuspenseFetchUser = ({ setUser }: UseSuspenseFetchUserOptions): User => {
  const { data } = useSuspenseQuery({
    queryKey: [QUERY_KEYS.FETCH_USER],
    queryFn: () => UsersService.getUser(),
    select: response => response.data,
  });

  useEffect(() => {
    setUser(data);
    i18nService.changeLanguage(data.appLanguage);
  }, [data, setUser]);

  return data;
};
